import cn from 'classnames';

interface CardProps {
  dark?: boolean;
}

export default function Card({
  dark,
  className,
  children,
  ...props
}: CardProps & React.HTMLProps<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'py-7 w-full rounded-2xl shadow-md overflow-hidden',
        { 'bg-blue-800 text-white': dark, 'bg-white text-black': !dark },
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
